"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenMessages = exports.LocalizationProvider = void 0;
var provider_1 = require("./provider");
Object.defineProperty(exports, "LocalizationProvider", { enumerable: true, get: function () { return provider_1.LocalizationProvider; } });
var utils_1 = require("./utils");
Object.defineProperty(exports, "flattenMessages", { enumerable: true, get: function () { return utils_1.flattenMessages; } });
//# sourceMappingURL=index.js.map